// extracted by mini-css-extract-plugin
export default {"imageWrapper":"lazyimage_style_imageWrapper__SbO8b"};